<template>
  <div>
    <Breadcrumbs :title="user.firstName + ' ' + user.lastName"/>
    <!-- Container-fluid starts-->
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <div class="row">
                <div class="col-6">
                  <h5>Referral Code</h5>
                  <span>
                                        <router-link :to="{ name: 'referral', params: params({code: referralCode.referralCode})}" target= '_blank'>
                                            <i class="fa fa-link"></i>{{referralCode.referralCode}}
                                        </router-link>
                                    </span>
                </div>
                <b-modal id="modal-3" hide-footer centered title="Add Manual Client" class="theme-modal">
                  <form class="theme-form" @submit.prevent="handleSubmit" v-if="openModal">
                    <div class="form-group">
                      <label for="firstName" class="col-form-label">First Name <span>*</span></label>
                      <input type="text" v-model="users.firstName" id="firstName" name="firstName" class="form-control" :class="{ 'is-invalid': submitted && $v.users.firstName.$error }" />
                      <div v-if="submitted && !$v.users.firstName.required" class="invalid-feedback">First Name is required</div>
                    </div>
                    <div class="form-group">
                      <label for="lastName" class="col-form-label">Last Name <span>*</span></label>
                      <input type="text" v-model="users.lastName" id="lastName" name="lastName" class="form-control" :class="{ 'is-invalid': submitted && $v.users.lastName.$error }" />
                      <div v-if="submitted && !$v.users.lastName.required" class="invalid-feedback">Last Name is required</div>
                    </div>
                    <div class="form-group">
                      <label for="email" class="col-form-label">Email <span>*</span></label>
                      <input type="email" v-model="users.email" id="email" name="email" class="form-control" :class="{ 'is-invalid': submitted && $v.users.email.$error }" />
                      <div v-if="submitted && $v.users.email.$error" class="invalid-feedback">
                        <span v-if="!$v.users.email.required">Email is required</span>
                        <span v-if="!$v.users.email.email">Email is invalid</span>
                      </div>
                    </div>
                    <div class="form-row">
                      <div class="col-sm-12">
                        <div class="loading-wrapper">
                          <div class="btn-loading" v-if="loading">
                            <div class="lds-ring"><div></div><div></div><div></div><div></div></div>
                          </div>
                          <button class="btn btn-primary">Add</button>
                        </div>
                      </div>
                    </div>
                  </form>
                </b-modal>
              </div>
            </div>
            <div class="card-body" v-if="loadingTable">
              <div class="loader-box d-flex justify-content-center">
                <div class="loader">
                  <div class="line bg-primary"></div>
                  <div class="line bg-primary"></div>
                  <div class="line bg-primary"></div>
                  <div class="line bg-primary"></div>
                </div>
              </div>
            </div>
            <div class="card-body" v-else>
              <b-row>
                <b-col md="6">
                  <b-button id="default-primary"  v-b-modal.modal-3 variant="primary">+ New Client</b-button>
                </b-col>
                <b-col md="6" v-if="totalItems !== 0">
                  <b-form-group label-cols="2" label="Per page" class="mb-0 datatable-select">
                    <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-alert show variant="primary" class="alert alert-primary outline text-center mt-4" v-if="totalItems === 0">
                <p>You don't have a client yet</p>
              </b-alert>

              <div class="table-responsive datatable-vue" v-if="totalItems !== 0">
                <table class="table b-table b-table-stacked-md">
                  <thead>
                  <tr>
                    <th v-for="(field, i) in tablefields" :key="i">{{field.label}}</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-if="items.length === 0">
                    <td colspan=5>No Clients Found</td>
                  </tr>
                  <tr v-for="(item, i) in items" :key="i" v-else>
                    <td>{{item.signedUp}}</td>
                    <td>{{item.email}}</td>
                    <td>
                      <b-badge variant="success" v-if="item.isManuallyAdded">Manual</b-badge>
                      <b-badge variant="primary" v-else>Referral</b-badge>
                    </td>
                    <td>{{item.actions}}</td>
                    <td class="trash-wrapper">
                      <div class="d-flex">
                        <router-link v-b-tooltip.hover title="See SMARTracs" class="btn-sm btn-primary btn-trash mr-2" :to="'user-trac/' + item.id">
                          <i class="fa fa-eye"></i>
                        </router-link>
                        <button v-b-tooltip.hover title="Delete" class="btn-sm btn-danger btn-trash" @click="deleteUser(item.email)">
                          <i class="icon-trash"></i>
                        </button>
                      </div>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>

              <b-col md="6" class="my-1" v-if="totalItems !== 0">
                <b-pagination
                    v-model="currentPage"
                    :total-rows="totalItems"
                    :per-page="perPage"
                    class="my-0"
                ></b-pagination>
              </b-col>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Container-fluid Ends-->

    <div class="status-modal success-page" v-if="status === 1">
      <div class="status-content">
        <feather type="check" stroke="#24b47e" size="50"></feather>
        <h2>Confirmed</h2>
        <p>You have been successfully upgraded!</p>
        <button class="btn btn-primary" @click="status = null">Close</button>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import {required, email} from "vuelidate/lib/validators";
import { mapActions } from 'vuex'
import zapier from "../services/zapier";

export default {
  data() {
    return {
      users: {
        firstName: "",
        lastName: "",
        email: ""
      },
      openModal: true,
      loading: false,
      loadingTable: false,
      submitted: false,
      items: [],
      tablefields: [
        {key: 'signedUp', label: 'SignedUp', sortable: true},
        {key: 'email', label: 'Email', sortable: true},
        {key: 'type', label: 'Type', sortable: true},
        {key: 'actions', label: 'Actions', sortable: true},
        {key: 'delete', label: '', sortable: true},
      ],
      currentPage: 1,
      perPage: 10,
      totalItems: 0,
      pageOptions: [5, 10, 15],
      referralCode: '',
      referralCodeUrl: '',
      user: [],
      location: window.location.origin,
      status: null
    }
  },
  mounted() {
    if (localStorage.getItem('status')) {
      this.status = +localStorage.getItem('status');
      localStorage.removeItem('status')
    }
    this.fetchData();

    this.user = JSON.parse(localStorage.getItem('userinfo'));

    this.referralCode = JSON.parse(localStorage.getItem('userinfo'));
  },
  validations: {
    users: {
      firstName: { required },
      lastName: { required },
      email: { required, email }
    }
  },
  methods: {
    ...mapActions([
      'deleteUserApi'
    ]),
    params(newParams) {
      return {
        ...this.$route.params,
        ...newParams
      }
    },
    deleteUser(email) {
      this.$swal({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        type:'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.value) {
          this.deleteUserApi(email).then((res) => {
            if (res.data.statusCode === 200) {
              let text = res.data.message;
              this.$toasted.show(text, {
                theme: 'bubble',
                position: "bottom-right",
                type: 'success',
                duration: 2000
              });
              this.fetchData();
            } else {
              let text = res.data.result;
              this.$toasted.show(text, {
                theme: 'bubble',
                position: "bottom-right",
                type: 'error',
                duration: 2000
              });
            }
          })
        }
      }).catch(() => {
        this.$toasted.show('Please try again', {
          theme: 'bubble',
          position: "bottom-right",
          type: 'error',
          duration: 2000
        });
      })
    },
    handleSubmit() {
      this.submitted = true;

      // stop here if form is invalid
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }

      this.loading = true;

      let user = {"firstName": this.users.firstName, "lastName": this.users.lastName, "email": this.users.email};

      let self = this;

      this.$store.dispatch('registerManually', user).then( async (val) => {
        self.loading = false;
        if (val.status === 200) {
          self.$bvModal.hide('modal-3');
          self.users = {
            firstName: "",
            lastName: "",
            email: ""
          };
          if (val.data.result.isFirstTime) {
            let userinfo = localStorage.getItem('userinfo');
            await zapier.addsFirstClient(JSON.parse(userinfo));
          }
          this.submitted = false;
          self.$v.$reset();
          self.$toasted.show(' Successfully added ', {
            theme: 'bubble',
            position: "bottom-right",
            type: 'success',
            duration: 2000
          });
          this.fetchData();
        } else {
          self.$toasted.show(' Please try again ', {
            theme: 'bubble',
            position: "bottom-right",
            type: 'error',
            duration: 2000
          });
        }
      }).catch((err) => {
        let errorText = "";
        if(err.response.data) {
          errorText = err.response.data.responseException.exceptionMessage;
        }

        this.$toasted.show(errorText ? errorText : "Please try again", {
          theme: 'bubble',
          position: "bottom-right",
          type: 'error',
          duration: 4000
        });
        this.loading = false;
      });
    },
    async fetchData() {
      this.loadingTable = true;
      let data = {
        limit: this.perPage, page: this.currentPage-1
      };
      this.$store.dispatch('getReferrals', data).then(() => {
        this.totalItems = this.$store.state.referrals.totalCount;
        this.items = [];
        if (this.$store.state.referrals.userReferralInfos) {
          this.$store.state.referrals.userReferralInfos.forEach((val) => {
            this.items.push({
              id: val.id,
              signedUp: moment(val.signUpDateTime).format('MMM D, YYYY'),
              email: val.email,
              isManuallyAdded: val.isManuallyAdded,
              actions: "View Stats",
            })
          });
        }

        this.loadingTable = false
      });
    }
  },
  watch: {
    currentPage: {
      handler: function() {
        this.fetchData()
      }
    },
    perPage: {
      handler: function() {
        this.fetchData()
      }
    }
  }
}
</script>

<style lang="scss">
.card-header {
  span {
    margin-top: 10px !important;
  }
  a {
    color: #333;
  }
  i {
    margin-right: 5px;
  }
}
#urlValue {
  position: fixed;
  z-index: -9999;
  top: -9999999px;
  left: -9999999px;
}
.card .card-header span {
  font-size: 12px;
  color: #777777;
  margin-top: 5px;
  display: block;
  letter-spacing: 1px;
}
.form-group label>span {
  color: #dc3545;
}
.type-data {
  padding: 2px 15px;
  border-radius: 13px;
  color: #fff;

  &.manual {
    background: #7ec37b;
  }
  &.referral {
    background: #7892fc;
  }
}
.trash-wrapper {
  width: 70px;

  .btn-trash, .btn-primary {
    border: 1px solid;
    outline: none;
  }
}
.status-modal {
  position: fixed;
  z-index: 9999;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #21212166;

  .status-content {
    background-color: #fff;
    box-shadow: 0 11px 15px -7px #00000033, 0 24px 38px 3px #00000024, 0 9px 46px 8px #0000001f;
    border-radius: 4px;
    padding: 40px;
    text-align: center;

    i {
      color: #24b47e;
      width: 50px;
    }
  }
}
</style>
